import { dispatchUserMessage } from "@/hooks/use-dispatch-user-message";
import { getDurableConversation } from "@/api/conversations";
import { useInputBarTarget } from "@/stores/input-bar-target-store";
import { isSubagentTarget } from "./input-bar-target-kind";
import type { ScreenRecordingsContext } from "./screen-recordings-context";

/** Attached answers use the existing follow-up route, which resolves the
 * parked question and delivers the files in the same provider turn. The
 * question may live in any project, whichever one is being viewed. */
export async function submitQuestionAttachments(options: {
  projectId: string;
  conversationId: string | null | undefined;
  executionId?: string;
  awaitingInputId: string;
  text: string;
  imageIds: string[];
  screenRecordings?: ScreenRecordingsContext;
  nativeChildInstruction?: boolean;
  isCancelled?: () => boolean;
}): Promise<boolean> {
  if (options.isCancelled?.() || !options.conversationId) return false;
  let nativeChildInstruction = options.nativeChildInstruction;
  if (nativeChildInstruction === undefined) {
    const target = useInputBarTarget.getState().target;
    if (
      isSubagentTarget(target) &&
      target.conversationId === options.conversationId
    )
      nativeChildInstruction = true;
    else {
      const conversation = await getDurableConversation(options.conversationId);
      if (conversation.project_id !== options.projectId) return false;
      nativeChildInstruction = conversation.context_key.startsWith("native:");
    }
  }
  if (options.isCancelled?.()) return false;
  const result = dispatchUserMessage({
    text: options.text,
    imageIds: options.imageIds,
    screenRecordings: options.screenRecordings,
    execId: options.executionId,
    awaitingInputId: options.awaitingInputId,
    conversationId: options.conversationId,
    nativeChildInstruction,
    literalText: true,
    startNewConversation: false,
    ignoreInputBarSessionState: true,
    position: { x: 0, y: 0 },
  });
  return result.sent ? result.accepted : false;
}
